import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ComercioExteriorDestinatarioDomicilioManager from './ComercioExteriorDestinatarioDomicilioManager';

class ComercioExteriorDestinatarioForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      isValidAddress: false,
      isTouchedDomicilio: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        domicilioChecked: !!data.Domicilio,
        isValid: true
      });
    }
  }

  rules(data) {
    return {
      'NumRegIdTrib': ['string', 'min:6', 'max:40'],
      'Nombre': ['string', 'min:1', 'max:300', 'regex:/^[^|]{1,300}$/'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnIgnore = () => {
    this.setState({
      data: {},
      isValid: false
    });

    this.props.onIgnore();
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      domicilioChecked: false,
      data: {}
    })
  }

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });
  }

  handleOnAdditionalChange = (additional) => {
    this.setState({
      data: {
        ...this.state.data,
        ...additional
      }
    });
  }

  render() {
    const rules = this.rules();
    const {
      isValid,
      domicilioChecked,
      data = {},
    } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="NumRegIdTrib"
              name="NumRegIdTrib"
              placeholder=""
              help=""
              minLength="6"
              maxLength="40"
              rules={ rules.NumRegIdTrib }
              value={ data.NumRegIdTrib }
              onChange={ this.handleOnChange }
            />
          </Col>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Nombre"
              name="Nombre"
              placeholder=""
              help=""
              minLength="1"
              maxLength="300"
              rules={ rules.Nombre }
              value={ data.Nombre }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <strong>Domicilio</strong>
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varios Destinatarios usando el botón "Agregar Destinatario", la lista se mostrarán en la tabla de Destinatarios.
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="domicilioChecked">
              <Form.Check type="checkbox"
                name="domicilioChecked"
                label="Incluir domicilio"
                checked={ domicilioChecked || false }
                onChange={ this.handleOnAdditionalCheckboxChange }
              />
            </Form.Group>
          </Col>
        </Row>

        { !!domicilioChecked && (
          <ComercioExteriorDestinatarioDomicilioManager
            data={ data }
            onChange={ this.handleOnAdditionalChange }
          />
        )}


        <div className="py-2">
          En este nodo se pueden expresar los datos del destinatario de la mercancía cuando este sea distinto del receptor del comprobante, o bien cuando el domicilio se trate de alguna sucursal. Si el tipo de comprobante es “T” (Traslado), solo se puede registrar un destinatario.
        </div>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              className="mr-2"
              onClick={ this.handleOnIgnore }
            >
              Omitir Destinatario
            </Button>

            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Destinatario
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default ComercioExteriorDestinatarioForm;